import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assign-leave',
  templateUrl: './assign-leave.component.html'
})
export class AssignLeaveComponent implements OnInit {
  public partialDay:string="0";
  public leaveTypes:string="2";
  public startDay:string="0";
  public endDay:string="0";
  public halfDay:string="0";
  public halfDay2:string="0";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/assign-leave/assign-leave.component.ts